import React from 'react';
import Seo from '../components/common/Seo';
import PageHero from '../components/common/PageHero';
import LogoGrid from '../components/common/LogoGrid';
import { jordanClients, internationalClients } from '@/data/clients';
import { seo } from '@/data/seo';

const Clients = () => {
  return (
    <div className="min-h-screen bg-white pt-20">
      <Seo {...seo.clients} />
      <PageHero
        eyebrow="Clients"
        title="Organisations we serve"
        highlight="in Jordan and beyond"
        description="A selection of organisations published on MAYAN Technology’s client list, including clients outside Jordan."
      />

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-8">Clients in Jordan</h2>
            <LogoGrid items={jordanClients} />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-8">Some clients outside Jordan</h2>
            <LogoGrid items={internationalClients} columns="grid-cols-2 sm:grid-cols-3 lg:grid-cols-4" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Clients;
